// docs/116 CI16: the innkeeper's offer of a room upstairs, paid once a visit.
import { useState } from 'react';
import { Button } from '../../../../components';
import { playSfx } from '../../../../../core/audio';
import { useInn } from '../store';
import { ROOM_PRICE, type InnData } from '../types';
import { HeroPick, SidePanel, firstPayer } from './common';

export function RoomPanel({ data }: { data: InnData }): React.JSX.Element {
  const [hero, setHero] = useState(() => firstPayer(data.payers, ROOM_PRICE)?.id);
  const [busy, setBusy] = useState(false);
  const [bad, setBad] = useState<string>();
  const payer = data.payers.find((p) => p.id === hero) ?? firstPayer(data.payers, ROOM_PRICE);
  const short = !payer || payer.gold < ROOM_PRICE;
  const up = () => { playSfx('inn.stairs'); useInn.getState().close(); data.act.upstairs(true); };
  const rent = async () => {
    if (!payer) return;
    setBusy(true);
    const ok = await data.act.rent(payer.id);
    setBusy(false);
    if (ok) playSfx('ui.coins', { gain: 0.45 });
    else { playSfx('ui.error'); setBad('The innkeeper frowns at the coins. Something isn\'t right.'); }
  };
  return (
    <SidePanel name="room" title="A room for the night" className="fk-innp__roomp">
      {data.rented ? <>
        <p className="fk-innp__keeper">“Your room's ready, up the stairs and second on the left. The quilts are aired and there's a candle lit.”</p>
        <Button primary block onClick={up} data-testid="inn-room-up">Go up to your room</Button>
      </> : <>
        <p className="fk-innp__keeper">“A room for the band? {ROOM_PRICE} gold for the night: beds with proper quilts, a wash stand, and the window looks out on the lane. Breakfast is whatever the rooster leaves you.”</p>
        <HeroPick payers={data.payers} value={payer?.id} onChange={setHero} label="Who pays" price={ROOM_PRICE} testid="inn-room-hero" />
        <Button primary block disabled={busy || short} onClick={() => void rent()} data-testid="inn-room-rent">{short ? `${payer?.name ?? 'Nobody'} is short of ${ROOM_PRICE} gold` : `Take the room · ${ROOM_PRICE}g`}</Button>
        {bad && <p className="fk-innp__said is-bad" role="status">{bad}</p>}
      </>}
    </SidePanel>
  );
}
